"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createStyles = _interopRequireDefault(require("../utils/createStyles"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = theme => _objectSpread(_objectSpread(_objectSpread({
  chip: {
    marginRight: 4,
    marginBottom: 2,
    display: 'inline-flex',
    background: theme.chip.background,
    borderColor: theme.chip.borderColor,
    borderWidth: 1,
    borderStyle: 'solid',
    padding: '0 12px',
    boxSizing: 'border-box',
    alignItems: 'center',
    position: 'relative',
    '&.unspaced': {
      margin: 0
    },
    // Just apply the same color as on the background to achieve unbordered effect
    '&.unbordered': {
      borderColor: theme.chip.background
    }
  }
}, (0, _createStyles.default)('backgroundColor', theme.palette)), (0, _createStyles.default)('borderColor', theme.palette)), {}, {
  avatar: {
    marginLeft: -12,
    marginRight: 8,
    width: 30,
    height: 30
  },
  label: {
    maxWidth: theme.chip.maxLengthText,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  icon: {
    marginRight: 8
  },
  closeIcon: {
    cursor: 'pointer',
    marginLeft: 8,
    color: theme.chip.closeIconColor
  },
  micro: {
    height: theme.chip.micro.height,
    padding: '0 4px'
  },
  small: {
    height: theme.chip.small.height,
    '& $avatar': {
      width: 18,
      height: 18
    }
  },
  medium: {
    height: theme.chip.medium.height
  },
  large: {
    height: theme.chip.large.height,
    '& $avatar': {
      width: 38,
      height: 38
    }
  },
  rounded: {
    borderRadius: theme.chip.medium.height / 2,
    '&$small': {
      borderRadius: theme.chip.small.height / 2
    },
    '&$large': {
      borderRadius: theme.chip.large.height / 2
    }
  },
  rectangular: {
    borderRadius: theme.chip.medium.rectangular.borderRadius,
    '&$small': {
      borderRadius: theme.chip.small.rectangular.borderRadius,
      '& $avatar': {
        borderRadius: theme.chip.small.rectangular.borderRadius
      }
    },
    '&$large': {
      borderRadius: theme.chip.large.rectangular.borderRadius,
      '& $avatar': {
        borderRadius: theme.chip.large.rectangular.borderRadius
      }
    },
    '& $avatar': {
      borderRadius: theme.chip.medium.rectangular.borderRadius
    }
  }
});
exports.default = _default;